(() => {
  if (window.bdmWishlistReady) return;
  window.bdmWishlistReady = true;

  const storageKey = "wishlist";
  const countKey = "user_wishlist_cnt";

  function read() {
    try {
      const value = JSON.parse(localStorage.getItem(storageKey) || "[]");
      if (!Array.isArray(value)) return [];
      return [...new Set(value.filter((handle) => typeof handle === "string" && handle))];
    } catch {
      return [];
    }
  }

  function write(handles) {
    localStorage.setItem(storageKey, JSON.stringify(handles));
    localStorage.setItem(countKey, String(handles.length));
  }

  function sync(root = document) {
    const handles = read();
    const selected = new Set(handles);

    root.querySelectorAll(".wishlist[data-handle]").forEach((button) => {
      const active = selected.has(button.dataset.handle);
      button.classList.toggle("active-wishlist", active);
      button.classList.toggle("wishlist-custom-action", !active);
      button.setAttribute("aria-pressed", String(active));
      const productName = button.dataset.productTitle || button.dataset.handle;
      button.setAttribute(
        "aria-label",
        active
          ? `Quitar ${productName} de favoritos`
          : `Agregar ${productName} a favoritos`
      );
    });

    document.querySelectorAll(".wishlist-counter").forEach((counter) => {
      counter.textContent = String(handles.length);
    });
    return handles;
  }

  document.addEventListener("click", (event) => {
    const button = event.target.closest(".wishlist[data-handle]");
    if (!button) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    const handles = read();
    const index = handles.indexOf(button.dataset.handle);
    if (index >= 0) handles.splice(index, 1);
    else handles.push(button.dataset.handle);

    write(handles);
    sync();
    document.dispatchEvent(
      new CustomEvent("bdm:wishlist-changed", {
        detail: { handles: [...handles] },
      })
    );
  }, true);

  document.addEventListener("DOMContentLoaded", () => sync());
  window.bdmWishlist = { read, sync };
})();
